export const OPTIMIZELY_PROJECT_NAME = 'default';
export const RECEIVED_ASSIGNMENTS = '@@abservice/RECEIVED_ASSIGNMENTS';
export const AB_OVERRIDES_COOKIE_KEY = 'testAbSystemOverrides';
export const AB_ROOT_KEY = 'absystem';

export const VISITOR_ID_TYPES = {
    sessionId: 'sessionId',
    trackingId: 'trackingId',
};

export const VARIANT_ON = 'on';
export const VARIANT_OFF = 'off';
